import { render, staticRenderFns } from "./ImageMedia.vue?vue&type=template&id=1cda36f8"
import script from "./ImageMedia.vue?vue&type=script&lang=ts"
export * from "./ImageMedia.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports